
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class LoginInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (httpRequest.url.includes("/Captcha") || httpRequest.url.includes("/Login")) 
      httpRequest = httpRequest.clone({ withCredentials: true});
    

    return next.handle(httpRequest)
      .pipe(catchError(err => {
        return throwError(() => err);
      }))
  }
}

export const HttpLoginInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LoginInterceptor, multi: true },
];
